import { BrowserRouter, Route, Routes, useLocation } from "react-router";
import Home from "./Component/Home";
import Header from "./Component/Header";
import './style.css';
import Privacy from "./Component/Privacy";
import Terms from "./Component/Terms";
import ScrollTop from "./Component/ScrollTop";
import "react-calendar/dist/Calendar.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Scroll from "./Component/Scroll";
import ReactGA from "react-ga4";
import { useEffect } from "react";
import About from "./Component/About";
import Contact from "./Component/Contact";
import Blog from "./Component/Blog";
import Bloginfo from "./Component/Bloginfo";
import Investment from "./Component/types-of-bank/Investment";
import Commercial from "./Component/types-of-bank/Commercial";
import Creditunion from "./Component/types-of-bank/Creditunion";
import Onlinebank from "./Component/types-of-bank/Onlinebank";
import Centralbank from "./Component/types-of-bank/Centralbank";
import Communitybank from "./Component/types-of-bank/Communitybank";
import Accounttype from "./Component/account-type/Accounttype";
import Bankingservice from "./Component/banking-service/Bankingservice";


function App() {
  const TRACKING_ID = "G-HMMF0FV183";
  function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    ReactGA.initialize(TRACKING_ID);
  }, []);

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname });
  }, [location]);

  return null;
}
  return (
    < >
     <BrowserRouter>
     <AnalyticsTracker />
     <Header/>
     <ScrollTop/>
     <Scroll/>
     <Routes>
      <Route path="/" element={<Home/>} />
      <Route path="/about" element={<About/>} />
      <Route path="/contact" element={<Contact/>} />
      <Route path="/blogs" element={<Blog/>} />
      <Route path="/blog/:id" element={<Bloginfo />} />
      <Route path="/privacypolicy" element={<Privacy/>} />
      <Route path="/termsofuse" element={<Terms/>} />
      <Route path="/commercialbank" element={<Commercial/>} />
      <Route path="/investmentbank" element={<Investment/>} />
      <Route path="/creditunion" element={<Creditunion/>} />
      <Route path="/onlinebank" element={<Onlinebank/>}/>
      <Route path="/centralbank" element={<Centralbank/>}/>
      <Route path="/communitybank" element={<Communitybank/>}/>
      <Route path="/account/:id" element={<Accounttype />} />
      <Route path="/investment/:id" element={<Bankingservice />} />
     </Routes>
     </BrowserRouter>
    </>
  );
}

export default App;
